import './Hero.css';

import { useTranslation } from 'react-i18next';

function Hero() {

  const { t } = useTranslation();

  return (

    <section className="hero" id="home">

      <div className="hero-container">

        <div className="hero-content">

          <p className="hero-label">
            {t('hero.label')}
          </p>

          <h1>
            {t('hero.title')}
          </h1>

          <p className="hero-description">
            {t('hero.description')}
          </p>

          <div className="hero-buttons">

            <a
              href="#portfolio"
              className="button-primary"
            >
              {t('hero.buttonPortfolio')}
            </a>

            <a
              href="#contact"
              className="button-secondary"
            >
              {t('hero.buttonContact')}
            </a>

          </div>

        </div>

        <div className="hero-image">

          <div className="image-placeholder">
            Your Photo
          </div>

        </div>

      </div>

    </section>

  );

}

export default Hero;